var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useState, useEffect, useCallback } from 'react';
import { getUIMap, genUIBlock, serializeResponseBody, serializeLogicString, } from '../UIJsonParser/transformations';
import { usePrevious } from '../hooks/usePrevious';
import RuleCondition from './RuleCondition';
import RuleRender from './RuleRender';
import { v4 as uuidv4 } from 'uuid';
import { FlightSnackbar } from '@flybits/design-system';
import '../assets/styles/index.scss';
export var RuleContainer = function (_a) {
    var _b, _c, _d, _e;
    var responseJSON = _a.responseJSON, _f = _a.isSerializeUiModel, isSerializeUiModel = _f === void 0 ? false : _f, serializeUiModel = _a.serializeUiModel, contextPlugins = _a.contextPlugins, contentInstances = _a.contentInstances, contextLabels = _a.contextLabels, historicalQueries = _a.historicalQueries, _g = _a.expandAllConditions, expandAllConditions = _g === void 0 ? false : _g, locationProps = _a.locationProps, contentAnalyticsProps = _a.contentAnalyticsProps;
    var uiMap = getUIMap(responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.payload, contextPlugins);
    var _h = __read(useState(expandAllConditions), 2), isExpandAll = _h[0], setIsExpandAll = _h[1];
    var _j = __read(useState(false), 2), isError = _j[0], setIsError = _j[1];
    var _k = __read(useState(''), 2), logicOperator = _k[0], setLogicOperator = _k[1];
    var _l = __read(useState(''), 2), logicString = _l[0], setLogicString = _l[1];
    var _m = __read(useState(false), 2), isCustomLogic = _m[0], setIsCustomLogic = _m[1];
    var _o = __read(useState({
        id: responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.id,
        refId: (responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.refId) || uuidv4().toUpperCase(),
        templateId: responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.templateId,
        name: (_b = responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.payload.name) !== null && _b !== void 0 ? _b : "Untitled Rule - ".concat(Date.now().toString()),
        headName: (_c = responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.payload.headName) !== null && _c !== void 0 ? _c : "ur-".concat(Date.now().toString()),
        scope: (_d = responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.payload.scope) !== null && _d !== void 0 ? _d : 'tenant',
        metadata: (_e = responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.payload.metadata) !== null && _e !== void 0 ? _e : '{}',
        condition: uiMap.condition,
        uiBlocks: uiMap.uiBlocks,
        contextPlugins: contextPlugins,
        contentInstances: contentInstances,
        constraints: uiMap.constraints,
        inheritedPayloadProperties: uiMap.inheritedPayloadProperties,
    }), 2), uiModel = _o[0], setUiModel = _o[1];
    var prevModel = usePrevious(uiModel);
    var handleExpandAllToggle = function () {
        var newExpandAll = !isExpandAll;
        setIsExpandAll(newExpandAll);
        setUiModel(__assign(__assign({}, uiModel), { uiBlocks: uiModel.uiBlocks.map(function (block) {
                return __assign(__assign({}, block), { isExpanded: newExpandAll });
            }) }));
    };
    var handleExpandToggle = function (nodeId) {
        var allExpanded = true;
        var allCollapsed = true;
        var newUiBlocks = uiModel.uiBlocks.map(function (block) {
            if (block.nodeId === nodeId) {
                allExpanded = allExpanded && !block.isExpanded;
                allCollapsed = allCollapsed && block.isExpanded;
                return __assign(__assign({}, block), { isExpanded: !block.isExpanded });
            }
            else {
                allExpanded = allExpanded && block.isExpanded;
                allCollapsed = allCollapsed && !block.isExpanded;
                return block;
            }
        });
        setUiModel(__assign(__assign({}, uiModel), { uiBlocks: newUiBlocks }));
        if (allExpanded)
            setIsExpandAll(true);
        if (allCollapsed)
            setIsExpandAll(false);
    };
    var addPredicate = function (ctxPlugin, attrKey, newUiBlockNodeId, uiBlock) {
        var _a, _b, _c;
        var hasPlaceHolder = ((_a = uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.hasPlaceHolder) === null || _a === void 0 ? void 0 : _a.name) ||
            ((_b = uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.hasPlaceHolder) === null || _b === void 0 ? void 0 : _b.contextOrHistorical) ||
            ((_c = uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.hasPlaceHolder) === null || _c === void 0 ? void 0 : _c.constant);
        if (hasPlaceHolder) {
            setUiModel(function (oldModel) {
                return __assign(__assign({}, oldModel), { uiBlocks: oldModel.uiBlocks.map(function (block) {
                        if (block.nodeId === (uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.nodeId)) {
                            return genUIBlock(ctxPlugin, attrKey, newUiBlockNodeId, uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.hasPlaceHolder, block);
                        }
                        else
                            return block;
                    }) });
            });
        }
        else {
            setUiModel(__assign(__assign({}, uiModel), { uiBlocks: __spreadArray(__spreadArray([], __read(uiModel.uiBlocks), false), [genUIBlock(ctxPlugin, attrKey, newUiBlockNodeId, uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.hasPlaceHolder)], false) }));
        }
    };
    var removePredicate = function (deletedNodeId) {
        setUiModel(function (oldModel) {
            return __assign(__assign({}, oldModel), { uiBlocks: oldModel.uiBlocks.filter(function (block) { return block.nodeId !== deletedNodeId; }) });
        });
    };
    var updatePredicateField = useCallback(function (updatedBlock) {
        setUiModel(function (oldModel) {
            return __assign(__assign({}, oldModel), { uiBlocks: oldModel.uiBlocks.map(function (block) {
                    if (block.nodeId === updatedBlock.nodeId) {
                        return updatedBlock;
                    }
                    else
                        return block;
                }) });
        });
    }, []);
    var updateLogicOperator = function (operator) {
        if (operator === void 0) { operator = ''; }
        setLogicOperator(operator.toLowerCase());
    };
    var handleOnError = function (hasError) {
        setIsError(hasError);
    };
    // Reset uiModel
    useEffect(function () {
        return function () {
            setUiModel({
                id: '',
                templateId: '',
                refId: '',
                condition: '',
                name: '',
                headName: '',
                scope: '',
                uiBlocks: [],
                contextPlugins: [],
                contentInstances: [],
                metadata: '{}',
            });
        };
    }, []);
    // Hydrate uiModel
    useEffect(function () {
        var newUiMap = getUIMap(responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.payload, contextPlugins);
        var newUiBlocks;
        if (uiModel.id === (responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.id) && uiModel.refId === (responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.refId)) {
            newUiBlocks = newUiMap.uiBlocks.map(function (block, index) {
                var _a;
                return __assign(__assign({}, block), { isExpanded: expandAllConditions || ((_a = uiModel.uiBlocks[index]) === null || _a === void 0 ? void 0 : _a.isExpanded) });
            });
        }
        else {
            newUiBlocks = newUiMap.uiBlocks;
        }
        setUiModel(function (oldModel) {
            var _a, _b, _c, _d;
            newUiBlocks.forEach(function (block) {
                oldModel.uiBlocks.forEach(function (oldBlock) {
                    if (block.nodeId === oldBlock.nodeId && oldBlock.historicalValue) {
                        block.historicalValue = oldBlock.historicalValue;
                    }
                });
            });
            return __assign(__assign({}, oldModel), { id: responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.id, refId: (responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.refId) || uuidv4().toUpperCase(), templateId: responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.templateId, name: (_a = responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.payload.name) !== null && _a !== void 0 ? _a : '', headName: (_b = responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.payload.headName) !== null && _b !== void 0 ? _b : '', scope: (_c = responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.payload.scope) !== null && _c !== void 0 ? _c : 'tenant', metadata: (_d = responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.payload.metadata) !== null && _d !== void 0 ? _d : '{}', condition: newUiMap.condition, uiBlocks: newUiBlocks, inheritedPayloadProperties: newUiMap.inheritedPayloadProperties });
        });
        if (responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.payload.metadata) {
            var parsedMetadata = JSON.parse(responseJSON.payload.metadata);
            setIsCustomLogic(parsedMetadata.isCustomLogic || false);
        }
    }, [responseJSON, contextPlugins]);
    // Update context plugins
    useEffect(function () {
        setUiModel(function (oldModel) {
            return __assign(__assign({}, oldModel), { contextPlugins: contextPlugins });
        });
    }, [contextPlugins]);
    /**
     Trigger callback function which is coming from
     outer layer and building serialized response. Then return it back to caller point
    */
    // Serialize uiModel
    useEffect(function () {
        if (isSerializeUiModel) {
            var serializedResponse = serializeResponseBody(uiModel, (prevModel === null || prevModel === void 0 ? void 0 : prevModel.condition) || '', logicOperator);
            serializeUiModel(serializedResponse);
        }
        // Build logic string for Rule condition bar - Display purpose only
        if (isCustomLogic) {
            setLogicString(uiModel.condition);
        }
        else {
            var conditionString = serializeLogicString(uiModel, (prevModel === null || prevModel === void 0 ? void 0 : prevModel.condition) || '', logicOperator);
            setLogicString(conditionString);
        }
    }, [isSerializeUiModel, uiModel, prevModel, logicOperator]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FlightSnackbar, { className: "rule-snack-bar", type: "error", icon: "blocked", isVisible: isError, isAutoDismiss: true, actionName: null, content: "Rule validation failed." }),
        React.createElement(RuleCondition, { conditionString: logicString || uiModel.condition, onChangeConditionKey: updateLogicOperator, isExpandAll: isExpandAll, onExpandToggleClick: handleExpandAllToggle, onError: handleOnError, isCustomLogic: isCustomLogic, setUiModel: setUiModel, setIsCustomLogic: setIsCustomLogic, uiBlocks: uiModel.uiBlocks }),
        React.createElement("br", null),
        React.createElement(RuleRender, __assign({}, uiModel, { handleExpandToggle: handleExpandToggle, addPredicate: addPredicate, removePredicate: removePredicate, updateUiBlock: updatePredicateField, locationProps: locationProps, contextLabels: contextLabels, historicalQueries: historicalQueries, contentAnalyticsProps: contentAnalyticsProps }))));
};
//# sourceMappingURL=RuleContainer.js.map